import { useState, useLayoutEffect, useRef, useEffect } from "react";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import './index.css';

interface Props {
  mensagem: string | undefined,
  tipo: string,
  delay: number | undefined,
}


const AlertCustomizado = ({ mensagem, tipo, delay}: Props) => {

  const intervalRef: { current: NodeJS.Timeout | null } = useRef(null);
  const [ show, setShow ] = useState<boolean>(true);

  useEffect(() => {
   
    return () => {
      fecharAlertaPorTime();
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

    //Se o usuário clicar para fechar a mensagem da kill no processo do setInterval iniciado na função abaixo
    useLayoutEffect(() => {

      if(!show){    
          clearInterval(intervalRef.current as NodeJS.Timeout);
      }
    }, [show])

  //Fechar a mensagem alerta em 20 segundos
  const fecharAlertaPorTime = async() => {
      intervalRef.current = setInterval(() => { 
        setShow(false);
       }, delay ? delay : 60000);
  }

  return (
    <>
      {
        show ?

          <Row className="mt-5 text-center">
            <Col xl={{ span: 10, offset: 1 }}>
              <Alert id="alerta" variant={tipo} onClose={() => setShow(false)} dismissible>
                <Alert.Heading> </Alert.Heading>
                <p className="fs-4">
                  {mensagem}
                </p>
              </Alert>
            </Col>
          </Row>

          : null

      }

    </>
  );
}

export default AlertCustomizado;